import React, { Component } from 'react';

//styles
import './SectionEight.scss';
import CountUpOnView from '../CountUpOnView/CountUpOnView';
import TrackVisibility from 'react-on-screen';

const HeartSvg = ({ isVisible }) => {
    return (
        <svg className={isVisible ? "heart-svg active" : "heart-svg"} xmlns="http://www.w3.org/2000/svg" width="270.482" height="250" viewBox="0 0 270.482 250">
            <defs>
            </defs>
            <g id="cardiogram_web" transform="translate(0 -19.387)">
                <g id="Group_71" data-name="Group 71" transform="translate(0 66.522)">
                    <g id="Group_70" data-name="Group 70">
                        <path  id="Path_589" stroke="#c7b198" strokeWidth="5"  d="M209.625 176.218H160.4l-11.978-35.952c-.938-2.813-3.661-5.031-6.563-4.621a6.742 6.742 0 0 0-6.352 4.9l-19.732 69.046-21.265-95.7a6.764 6.764 0 0 0-12.879-1.045l-25.358 63.37H6.762a6.762 6.762 0 1 0 0 13.524h54.1a6.739 6.739 0 0 0 6.275-4.251L86.059 138.2l22.292 100.35a6.773 6.773 0 0 0 6.406 5.3h.2a6.754 6.754 0 0 0 6.5-4.9l21.043-73.664 6.6 19.836a6.774 6.774 0 0 0 6.419 4.621h54.1a6.763 6.763 0 0 0 0-13.525z" className="cls-1" data-name="Path 589" transform="translate(0 -108.608)" />
                    </g>
                </g>
                <g id="Group_73" data-name="Group 73" transform="translate(.266 19.387)">
                    <g id="Group_72" data-name="Group 72">
                        <path id="Path_590" d="M246.955 43.153a80.557 80.557 0 0 0-111.475-2.677A80.7 80.7 0 0 0 3.082 120.62h14.066C9.935 97.39 15.2 71.081 33.566 52.72a67.063 67.063 0 0 1 92.034-2.958L135.48 59l9.886-9.241a67.057 67.057 0 0 1 92.027 2.957 67.7 67.7 0 0 1 0 95.63L135.48 250.259l-89.066-89.066H27.286L135.48 269.387l111.475-111.476a81.15 81.15 0 0 0 0-114.758z" className="cls-1" data-name="Path 590" transform="translate(-.504 -19.387)" />
                    </g>
                </g>
            </g>
        </svg>

    )
}

class SectionEight extends Component {

    render() {
        return (
            <div id="section8" className="section8-container">
                {/* <div className="image"></div> */}
                <div className="desc-container">
                    <div className="right-container">
                        <CountUpOnView start={70} end={76.2} prefix="תוחלת החיים – " suffix="שנה" decimals={1} />
                    </div>
                    <div className="left-container">
                        <div className="sub-text">איראן מדורגת במקום ה-<b>60</b> במדד איכות החיים של האו"ם</div>
                    </div>
                    
                </div>
                <TrackVisibility partialVisibility once>
                        <HeartSvg />
                    </TrackVisibility>
            </div>
        );
    }
}

export default SectionEight;


// WEBPACK FOOTER //
// ./src/Components/SectionEight/SectionEight.js